import { generateCssForMarkdown } from '../../../../alan_btn/src/styles/markdown';
import { addImgToThePage, adjustIFrameSize, broadcastThemeToIframes, iFrameSizeListenerFunctions, onIFrameSizeListener } from '../../../../alan_btn/src/textChat/helpers/adjustIFrameSize';
import { saveChatState } from '../../../../alan_btn/src/textChat/saveChatStateToFile';
import { IProject } from '../../models/IProject';
import projectLogsKeeper from '../dataKeepers/ProjectLogsKeeper';
import copyTextToBuffer from './copyTextToBuffer';

function escapeHtml(unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

export async function saveDebugChatMessages(project: IProject) {
    const { projectId, name } = project;

    const LIBS_PREFIX = 'https://storage.googleapis.com/alan-ai-public-resources/save-debug-chat-resources';

    const customCss = `
    ${generateCssForMarkdown('.with-markdown', '')}

    h1 {
        display: block;
        font-size: 2em;
        margin-block-start: 0.67em;
        margin-block-end: 0.67em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
        unicode-bidi: isolate;
    }

    @font-face {
        font-family: "alan-font";
        src:url("/web/src/assets/fonts/alan-font.eot") !important;
        src:url("/web/src/assets/fonts/alan-font.eot?#iefix") format("embedded-opentype"),
        url("/web/src/assets/fonts/alan-font.woff") format("woff"),
        url("/web/src/assets/fonts/alan-font.ttf") format("truetype"),
        url("/web/src/assets/fonts/alan-font.svg#alan-font") format("svg") !important;
        font-weight: normal!important;
        font-style: normal!important;
  }

    .debugging-chat {
        width: 100%!important;
        min-width: 100%!important;
    }

    .debugging-chat:before {
        display: none;
    }

    .chat-bubble_inspect-url {
        display: none;
    }

    .chat-bubble_r-Loc {
        padding-left: 12px !important;
        pointer-events: none;
    }

    .chat-bubble_r-Loc i {
        display: none!important;
    }

    .chat-bubble_r-Loc .r-Loc_link {
        text-decoration: none!important:
    }

    .chat-bubble_r-Loc .r-Loc_num {
        text-decoration: none!important:
    }

    .chat-bubble_graph {
        display: flex!important;
        cursor:pointer;
        margin-top: 4px;
        align-items: flex-end;
    }

    .chat-bubble_graph svg {
        max-width: 16px;
    }

    .chat-bubble_graph svg path {
        fill: #0079e8;
    }

    .chat-bubble_graph:hover svg path {
        fill: #ff8800;
    }

    .alan-btn__chat-response-commands-wrapper {
        display:none!important;
    }

    #overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #0000004d;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #popup {
        height: 90%;
        width: 90%;
        border-radius: 8px;
        background: #fff;
    }

    #popup-title {
        padding: 0 20px;
        height: 40px;
        position:relative;
        display:flex;
        align-items: center;
        justify-content: flex-start;
        font-weight: bold;
        font-size: 20px;
        border-bottom: 1px solid rgba(211, 211, 211, .5);
    }

    #popup-close-btn {
        position: absolute;
        top:10px;
        right:10px;
        cursor: pointer;
    }

    #graph {
        height:calc(100% - 40px);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #graph svg {
        backface-visibility: hidden;
        will-change: transform;
        width: 100%;
    }

    #graph svg text {
        font-size: 8.5px;
        font-family: monospace
    }

    #details {
        overflow: auto;
        height: calc(100% - 40px);
        font-family: monospace;
        white-space: pre;
    }

    .details-content {
        padding: 20px;
        overflow: auto;
        height: 100%;
    }

    .switcher-modes {
        position: absolute;
        right: 40px;
        display: flex;
        top: 50%;
        transform: translateY(-50%);
        border: 1px solid rgba(0, 121, 232,.5);
        background-color: rgba(176, 217, 255, 0.15);
        border-radius: 8px;
        align-items: center;
        justify-content: center;
    }

    .mode-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 4px;
    }

    .mode-btn.active {
        background-color: #b0d9ff73;
    }

    .mode-btn:first-of-type {
        border-right: 1px solid rgba(0, 121, 232,.5);
    }

    .mode-btn:last-of-type {
        border-left: 1px solid rgba(0, 121, 232,.5);
    }

    .mode-btn svg path {
        fill: rgba(0, 121, 232, 1);
    }

    .mode-btn:hover svg path {
        fill: #ff8800;
    }

    .mode-split {
        display: flex;
        justify-content: center;
    }

    .mode-split > div {
        width: 50%;
        min-width: 50%;
        max-width: 50%;
    }
    .mode-split > div:first-of-type {
        border-right: 1px solid rgba(211, 211, 211, .5);
    }

    pre code {
        overflow:hidden!important;
    }

    .alan-btn__chat-response__code-wrapper .alan-btn__chat-response__copy-code-btn svg path{
        fill: #17171780 !important;
    }

    .alan-btn__chat-response__code-wrapper .alan-btn__chat-response__copy-code-btn.alan-copy-btn-copied .alan-btn__copied-icon {
        stroke: #17171780 !important;
    }

    .alan-btn__chat-response__code-wrapper .alan-btn__chat-response__copy-code-btn:hover {
        background-color: #dcddde !important;
    }

    .chat-bubble_loading-msg {
        display: flex !important;
        align-items: center;
        gap: 4px;
        padding-left: 6px;
        animation: none!important;
    }

    .chat-bubble_loading-msg .chat-bubble_loading {
        padding-left: 0px;
    } 

    .incomming-msg-loader-wrapper {
        min-width: 22px;
    }

    .incomming-msg-loader-wrapper svg {
        width: 22px;
    }

    `;

    const initChat = document.querySelector('.debugging-chat');

    if (!initChat) return;

    const chatWidth = initChat.clientWidth;

    const chatEl = initChat.cloneNode(true) as HTMLDivElement;

    const children = Array.from(chatEl.children);

    children.forEach((child) => {
        if ((child.tagName === 'DIV' || child.tagName === 'SPAN') && !child.classList.contains('debugging-chat_messages')) {
            chatEl.removeChild(child);
        }
    });

    const outputPhrases = projectLogsKeeper.getLogs().filter(l => l.type?.toLowerCase() === 'output')
        .map(el => ({ ...el, context: escapeHtml(el?.context || ''), phrase: '' }))

    const headEl = document.head.cloneNode(true) as HTMLHeadElement

    const tagsToRemove = ['LINK', 'SCRIPT', 'META', 'TITLE'];

    for (let i = headEl.children.length - 1; i >= 0; i--) {
        const child = headEl.children[i];
        if (tagsToRemove.includes(child.tagName)) {
            headEl.removeChild(child);
        }
    }

    const customHeadContent = `
        ${headEl.innerHTML}
        <link href="${LIBS_PREFIX}/main.css" rel="stylesheet" />
        <link href="${LIBS_PREFIX}/highlight.light.css" rel="stylesheet" />
        <style>${customCss}</style>
        <script src="${LIBS_PREFIX}/d3.v7.min.js" type="text/javascript"></script>
        <script src="${LIBS_PREFIX}/viz-standalone.js" type="text/javascript"></script>
        <script src="${LIBS_PREFIX}/svg-pan-zoom.min.js" type="text/javascript"></script>
        <script src="${LIBS_PREFIX}/alan_markdown.js" type="text/javascript"></script>
        <script src="${LIBS_PREFIX}/highlight.min.js?v=2" type="text/javascript"></script>
        `;

    const functionsToInsert = iFrameSizeListenerFunctions.map(fn => fn.toString()).join('\n\n');
    const onIFrameSizeListenerString = onIFrameSizeListener.toString();
    const copyTextToBufferString = copyTextToBuffer.toString();

    const customCodeContent = `
        <script  type="text/javascript">

        ${functionsToInsert}
        ${copyTextToBufferString}
        window.addEventListener("message", ${onIFrameSizeListenerString});

        window.hljs.addPlugin({
            "after:highlightElement": ({ el, text }) => {
            const wrapper = el.parentElement;
            if (wrapper == null) {
                return;
            }

            wrapper.classList.add("alan-btn__chat-response__code-wrapper");

            const copyButton = document.createElement("span");
            copyButton.classList.add(
                "alan-btn__chat-response__copy-code-btn",
            );

            const chatIcons = {
                copy: '<svg  class="alan-btn__copy-icon" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 16.5L19.5 4.5L18.75 3.75H9L8.25 4.5L8.25 7.5L5.25 7.5L4.5 8.25V20.25L5.25 21H15L15.75 20.25V17.25H18.75L19.5 16.5ZM15.75 15.75L15.75 8.25L15 7.5L9.75 7.5V5.25L18 5.25V15.75H15.75ZM6 9L14.25 9L14.25 19.5L6 19.5L6 9Z" fill="#080341"/></svg>',
                copied: '<svg class="alan-btn__copied-icon" width="24px" height="24px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="#000000"> <title id="okIconTitle">Copied!</title> <polyline points="4 13 9 18 20 7"/> </svg>'
            };

            copyButton.innerHTML = chatIcons.copy + chatIcons.copied;

            copyButton.onclick = () => {
                copyTextToBuffer(text);

                copyButton.classList.add('alan-copy-btn-copied');
                setTimeout(() => {
                copyButton.classList.remove('alan-copy-btn-copied');
                }, 2000);
            };

            wrapper.appendChild(copyButton);
            },
        });

        function unescapeHtml(safe) {
            return safe
                .replace(/&lt;(?!\w)/g, "<")
                .replace(/(?<!\w)&gt;/g, ">")
                .replace(/&amp;/g, "&")
                .replace(/&quot;/g, '"')
                .replace(/&#039;/g, "'");
        }

        function escapeHtml(unsafe) {
            return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }
        
        var logs = ${JSON.stringify(outputPhrases)};
        
        logs = logs.map(el => ({
            ...el,
            context: unescapeHtml(el.context)
        }));
        
        var zoomInstance;
        var xRef, yRef, isDraggingRef;
        var dragThreshold = 5;
        var detailsId = null;
        var detailsMap = {};

        checkMsgLogs();

        function checkMsgLogs() {

            var graphIcons = document.querySelectorAll('.chat-bubble_graph');

            graphIcons.forEach((child) => {
                var msgReqId = child.getAttribute('data-request-id');
                if (logs.filter(l => l.requestId === msgReqId)?.length === 0) {
                    child.parentElement.removeChild(child);
                }
            });
        }

        document.addEventListener('mousedown', function onGraphClick(e) {
            var isOverlayEl = e.target.id === "overlay";

            if (isOverlayEl) {
                closePopup(e.target.getAttribute('popup-id'));
                return;
            }
        })

        document.addEventListener('click', function onGraphClick(e) {

            var graphEl = e.target.closest('.chat-bubble_graph');
            if (graphEl) {
                var phrase = logs.filter(l => l.requestId === graphEl.getAttribute('data-request-id'))[0];

                if (phrase) {
                    var graphData, graph, graphTitle;

                    try {
                        graphData = JSON.parse(phrase.context);
                        if (graphData && graphData.opGraph) {
                            graph = graphData.opGraph.dot;
                            graphTitle = graphData.opGraph.title;
                            detailsMap = graphData.opGraph.val;
                        }

                        console.info('graphData', graphData)
                    } catch (err) {
                        console.log(err);
                    }

                    createPopup('graph-popup','graph', graphTitle );

                    renderSvg(graph);
                }
            }
        })

        function createPopup (id, bodyId, title) {
              var overlay = document.createElement('div');
                var popup = document.createElement('div');
                var popupBody = document.createElement('div');
                var popupTitle = document.createElement('div');
                var popupCloseBtn = document.createElement('div');
                popupCloseBtn.innerHTML = '<svg width="20px" height="20px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"/></svg>';
                overlay.id = 'overlay';
                overlay.setAttribute('popup-id', id)
                popupBody.id = bodyId;
                popup.id = 'popup';
                popupTitle.id = 'popup-title';
                popupCloseBtn.id = 'popup-close-btn';

                overlay.appendChild(popup);
                popup.appendChild(popupTitle);
                popup.appendChild(popupBody);
                
                popupTitle.innerText = title;
                popupTitle.appendChild(popupCloseBtn);

                popupCloseBtn.addEventListener('click', ()=>{closePopup(id)});

                document.body.appendChild(overlay);
        }

        function cancelEvent(e) {
            e.stopPropagation();
            e.preventDefault();
        }

        const resetSelection = () => {
            d3.selectAll('#graph .selected').classed('selected', false);
        }

        const addGraphEvents = () => {
            const nodes = d3.selectAll('.node,.edge,.w-clicked-elements text');
            nodes.on("click", function (e) {
                if (isDraggingRef) {
                    cancelEvent(e);
                    return;
                }

                cancelEvent(e);
                resetSelection();
                const el = this.closest('[id]');

                if (el?.classList?.contains('node')) {
                    const id = el.getAttribute('id');
                    console.info('Id:', id);
                    if (detailsMap[id]) {
                        openDetailsPopup(id);
                    }
                    el.classList.add("selected");
                } else if (el?.firstChild?.tagName?.toLowerCase() === 'a') {
                    const id = el.getAttribute('id')?.replace('a_', '');
                    console.info('Id:', id);
                    if (detailsMap[id]) {
                        openDetailsPopup(id);
                    }
                    el.classList.add("selected");
                } else {
                    this.classList.add("selected");
                }
            });
        };

        function closePopup(popupId){
            var overlayEl = document.querySelector('[popup-id="'+popupId+'"]');
            if (overlayEl) {
                overlayEl.remove();
            }
        }

        function getSvg(graph, engine) {
            return new Promise((resolve, reject) => {
                try {
                 Viz.instance().then(viz => {
                        resolve(viz.renderSVGElement(graph, { engine }));
                    });
                } catch (error) {
                 console.info(error)
                    reject(error);
                }
            });
        }

        document.addEventListener('click', function (e){
            const clickedEl = e.target.closest('.mode-btn');
            if (!clickedEl) return;

            const mode = clickedEl.getAttribute('mode');

            if (!detailsId) return;

            renderDetailsContent(detailsId, mode);
        });

        function renderDetailsContent(id, mode){
            var detailsData = detailsMap[id];
            
            if (!detailsData) return;
            const detailsEl = document.getElementById('details');

            const elementsWithMode = document.querySelectorAll('[mode]');
            elementsWithMode.forEach(el => {
                el.classList.remove('active');
            });

            const curMode = document.querySelector('[mode="'+mode+'"]');
            if (curMode) {
                curMode.classList.add('active');
            }

            detailsEl.className = '';
            detailsEl.classList.add('mode-'+mode);

            var codePart = typeof detailsData.value === 'object' && detailsData.value !== null ? JSON.stringify(detailsData.value,null,2): escapeHtml(detailsData.value);
            var markdownPart = '';

            if (detailsData.type === 'markdown') {
                markdownPart = alanMarkdown(detailsData.value);
            }

            if (mode === 'code') {
                detailsEl.innerHTML = '<div class="details-content">'+codePart+'</div>';
            }

            if (mode === 'split') {
                detailsEl.innerHTML = '<div class="details-content">'+codePart+'</div><div class="details-content with-markdown">'+markdownPart+'</div>';
            }

            if (mode === 'preview') {
                detailsEl.innerHTML = '<div class="details-content with-markdown">'+markdownPart+'</div>';
            }

            detailsEl.querySelectorAll('pre code:not(.alan-btn__hljs-processed)').forEach((el) => {
                window.hljs.highlightElement(el);
                el.classList.add('alan-btn__hljs-processed');
            });
        }

        function openDetailsPopup(id){
            detailsId = id;
            var detailsData = detailsMap[id];
            
            if (!detailsData) return;
            
            createPopup('details-popup', 'details', detailsData.name);

            if (detailsData.type === 'markdown') {
                const detailsPopupEl = document.querySelector('[popup-id="details-popup"]');
                if (detailsPopupEl) {

                    const codeSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_1_30)"><path d="M6.12023 14.2531L0 10.9153V9.06662L6.12023 5.74774V7.91913L1.85555 9.96778L6.12023 12.0937V14.2531Z" fill="#010002" /><path d="M7.16559 15.4212L11.2243 4.5788H12.5066L8.43841 15.4212H7.16559Z" fill="#010002" /><path d="M13.8798 14.2531V12.0937L18.1436 9.98499L13.8798 7.89254V5.74689L20 9.07006V10.9076L13.8798 14.2531Z" fill="#010002" /></g><defs><clipPath id="clip0_1_30"><rect width="20" height="20" fill="white" /></clipPath></defs></svg>'; 
                    const splitSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.22222 17H4.55556C3.69689 17 3 16.3031 3 15.4444V4.55556C3 3.69611 3.69689 3 4.55556 3H15.4444C16.3039 3 17 3.69611 17 4.55556V15.4444C17 16.3031 16.3039 17 15.4444 17H10.7778V17.0179H9.22222V17ZM9.22222 15.4444V4.55556H4.55556V15.4444H9.22222ZM15.4444 4.55556H10.7778V15.4444H15.4444V4.55556Z" fill="black" /></svg>';
                    const previewSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M9.99535 12.9166C11.6062 12.9166 12.912 11.6108 12.912 9.99998C12.912 8.38915 11.6062 7.08331 9.99535 7.08331C8.38452 7.08331 7.07867 8.38915 7.07867 9.99998C7.07867 11.6108 8.38452 12.9166 9.99535 12.9166ZM9.99535 11.2453C9.3076 11.2453 8.75002 10.6877 8.75002 9.99998C8.75002 9.31223 9.3076 8.75465 9.99535 8.75465C10.6831 8.75465 11.2407 9.31223 11.2407 9.99998C11.2407 10.6877 10.6831 11.2453 9.99535 11.2453Z" fill="#0F0F0F" /><path fillRule="evenodd" clipRule="evenodd" d="M10 4.16669C5.99069 4.16669 3.26395 6.3409 1.82445 7.89984C0.714523 9.10185 0.714524 10.8982 1.82445 12.1002C3.26395 13.6592 5.99069 15.8334 10 15.8334C14.0094 15.8334 16.7361 13.6592 18.1756 12.1002C19.2855 10.8982 19.2855 9.10185 18.1756 7.89984C16.7361 6.3409 14.0094 4.16669 10 4.16669ZM3.04893 9.03052C4.32363 7.65004 6.63911 5.83335 10 5.83335C13.3609 5.83335 15.6764 7.65004 16.9511 9.03052C17.4714 9.59402 17.4714 10.406 16.9511 10.9695C15.6764 12.35 13.3609 14.1667 10 14.1667C6.63911 14.1667 4.32363 12.35 3.04893 10.9695C2.52858 10.406 2.52858 9.59402 3.04893 9.03052Z" fill="#0F0F0F" /></svg>';

                    const popupHeaderEl = detailsPopupEl.querySelector('#popup-title');
                    const modeSwitcherElement = document.createElement('div');
                    modeSwitcherElement.classList.add('switcher-modes');
                    modeSwitcherElement.innerHTML = '<div class="mode-btn" mode="code">'+codeSvg+'</div><div class="mode-btn" mode="split">'+splitSvg+'</div><div class="mode-btn" mode="preview">'+previewSvg+'</div>';
                    popupHeaderEl.appendChild(modeSwitcherElement);
                }
            }

            renderDetailsContent(id, 'code');

        }

        const renderSvg = async (graph) => {

        const graphEl = document.getElementById('graph');

            const height = graphEl.clientHeight || 500;
            const width = graphEl.clientWidth || 900;

            try {
                const svgEl = await getSvg(graph, 'dot');
                svgEl.setAttribute('width', width + 'px');
                svgEl.setAttribute('height', height + 'px');

                document.getElementById("graph").innerHTML = '';
                document.getElementById("graph").appendChild(svgEl);

                const svgD3 = d3.select('#graph svg');

                svgD3.on("mousedown", function (event) {
                    xRef = event.clientX;
                    yRef = event.clientY;
                    isDraggingRef = false;
                });

                svgD3.on("mousemove", function (event) {
                    if (event.buttons === 1) {
                        const dx = event.clientX - xRef;
                        const dy = event.clientY - yRef;
                        if (Math.sqrt(dx * dx + dy * dy) > dragThreshold) {
                            isDraggingRef = true;
                        }
                    }
                });

                zoomInstance = svgPanZoom(svgEl, {
                    zoomEnabled: true,
                    controlIconsEnabled: true,
                    fit: true,
                    center: true,
                    minZoom: 0.1,
                    maxZoom: 400
                });

                // if (predefinedZoom) {
                //     zoomInstance.zoom(predefinedZoom);
                // }

                // if (predefinedPan) {
                //     zoomInstance.pan(predefinedPan);
                // }

                // if (onPanZoomChange) {
                //     zoomInstance.setOnZoom((zoomLevel) => {
                //         onPanZoomChangeDebounced(zoomLevel, zoomInstance.getPan());
                //     });

                //     zoomInstance.setOnPan((pan) => {
                //         onPanZoomChangeDebounced(zoomInstance.getZoom(), pan);
                //     });
                // }

                svgEl.addEventListener('paneresize', function (e) {
                    zoomInstance.resize();
                }, false);
                window.addEventListener('resize', function (e) {
                    zoomInstance.resize();
                });
                console.timeEnd('render graph');

                addGraphEvents();


            } catch (error) {
              console.info(error)
            }
        };
    </script>
        `;




    await saveChatState(name, chatEl, chatWidth, projectId, customHeadContent, customCodeContent);
}
